// employee-frontend/src/features/queryResponses/queryResponseThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

// POST /api/query-responses/
export const createQueryResponseThunk = createAsyncThunk(
  'queryResponses/create',
  async (payload, { rejectWithValue }) => {
    try {
      // payload = { query, employee, store, date, time, subject, details, media }
      // If sending media, consider using FormData and 'multipart/form-data'.
      const response = await axiosInstance.post('/api/query-responses/', payload);
      return response.data;
    } catch (err) {
      return rejectWithValue('Failed to create query response');
    }
  }
);
